/**
 * Document Constants - Frontend
 * Mapping between uploaded document types and requiredDocuments field keys
 *
 * Keep in sync with server/config/constants.js DOC_TYPE_TO_REQUIRED_FIELD
 *
 * @module constants/documents
 */

// Map uploaded document types to requiredDocuments keys
export const DOC_TYPE_TO_REQUIRED_KEY = {
  dni: 'dni',
  passport: 'dni',
  death_certificate: 'deathCertificate',
  power_of_attorney: 'heirMandate',
  notary_document: 'heirMandate',
  legal_document: 'legitimationDocument',
  authorization_signed: 'authorization'
}

// Reverse mapping: checklist docKey -> backend document type
// docKeys come from DocumentationChecklist.vue (doc.id)
export const REQUIRED_KEY_TO_DOC_TYPE = {
  dni: 'dni',
  applicant_id: 'dni',
  death_certificate: 'death_certificate',
  deathCertificate: 'death_certificate',
  heirMandate: 'power_of_attorney',
  legitimationDocument: 'legal_document',
  authorization: 'authorization_signed',
  additional_document: 'additional_document'
}

// Additional document statuses
export const ADDITIONAL_DOC_STATUS = {
  PENDING: 'pending',
  UPLOADED: 'uploaded',
  APPROVED: 'approved',
  REJECTED: 'rejected'
}

// Required documents per case type / legalCapacity (mirrors Case.getRequiredDocumentsForType)
export const ADMIN_REQUIRED_DOCS = {
  olvido: [
    { key: 'dni', label: 'DNI / Documento de identidad' },
    { key: 'authorization', label: 'Autorización firmada' }
  ],
  heredero: [
    { key: 'dni', label: 'DNI / Documento de identidad' },
    { key: 'deathCertificate', label: 'Certificado de defunción' },
    { key: 'authorization', label: 'Autorización firmada' }
  ],
  albacea: [
    { key: 'dni', label: 'DNI / Documento de identidad' },
    { key: 'deathCertificate', label: 'Certificado de defunción' },
    { key: 'legitimationDocument', label: 'Testamento con designación de albacea' },
    { key: 'authorization', label: 'Autorización firmada' }
  ],
  familiar_allegado: [
    { key: 'dni', label: 'DNI / Documento de identidad' },
    { key: 'deathCertificate', label: 'Certificado de defunción' },
    { key: 'legitimationDocument', label: 'Documento de legitimación' },
    { key: 'authorization', label: 'Autorización firmada' }
  ],
  mandatario: [
    { key: 'dni', label: 'DNI / Documento de identidad' },
    { key: 'deathCertificate', label: 'Certificado de defunción' },
    { key: 'heirMandate', label: 'Poder notarial del heredero' },
    { key: 'authorization', label: 'Autorización firmada' }
  ],
  testamento: [
    { key: 'dni', label: 'DNI / Documento de identidad' }
  ]
}
